// extracted by mini-css-extract-plugin
export default {"stats":"statsDesktop_stats__tAiqk"};